@if (showElement) {
    <adapt-dashboard-element name="Actions"
                             [url]="url$ | async">
        <div *adaptLoadingUntilFirstEmit="let team of team$">
            @if (boards.length) {
                <div>
                    <div class="d-flex">
                        <div>
                            <ol class="item-counts">
                                @for (itemCount of itemCounts; track itemCount) {
                                    <li>
                                        <span class="item-count">{{ itemCount.count }}</span>
                                        <span>{{ itemCount.label }}</span>
                                    </li>
                                }
                            </ol>
                            @if (isTeamActive) {
                                <div>
                                    <button adaptButtonIcon="add"
                                            *adaptIfAuthorised="editTeamKanban; entity: team"
                                            (click)="createNewItem()">Add action</button>
                                </div>
                            }
                        </div>
                        @if (kanbanStats) {
                            <adapt-boards-item-statuses-graph [statusCounts]="kanbanStats.statusCounts"></adapt-boards-item-statuses-graph>
                        }
                    </div>
                </div>
            } @else {
                <div class="alert alert-guidance">
                    <p>
                        Teams can use actions to visualise their work and limit work in progress to enable more effective teamwork.
                        <span *adaptIfAuthorised="configureTeam; entity: team; else: noConfigurePermission"> Create a board in order to
                            manage team actions. </span>
                    </p>
                    <ng-template #noConfigurePermission> Team actions have not yet been set up by the team leader. </ng-template>
                </div>
            }
        </div>
    </adapt-dashboard-element>
}
